import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import service from './axios/api.js'
import less from 'less'
import 'default-passive-events'
import { Form, FormItem, Input, Checkbox, Button, Icon, Image, Avatar, Upload, RadioGroup, Radio, Drawer, Message, MessageBox, 
  Loading, Tooltip, Menu, Submenu, MenuItem, MenuItemGroup, Table, TableColumn, Select, Option, Dialog, Pagination, Tag } from 'element-ui';

Vue.config.productionTip = false
Vue.use(less)

Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Button)
Vue.use(Icon);
Vue.use(Image);
Vue.use(Avatar);
Vue.use(Upload);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Drawer);
Vue.use(Loading);
Vue.use(Tooltip);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Tag);


Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm

Vue.prototype.$http = service

new Vue({
  el: '#app',
  render: h => h(App),
  // 声明router
  router,
  // 在根上注册store
  store,
  beforeCreate(){
    // 安装全局事件总线
    Vue.prototype.$bus = this
  }
})
